import ExpiredDiscountsNotification from 'pages/CartPage/CartStep/ExpiredDiscountsNotification/ExpiredDiscountsNotification';

export default ExpiredDiscountsNotification;
